import { useCallback } from 'react';
import { analytics, events } from 'services/analytics';

const useTrackClick = (tileTitle: string) =>
  useCallback(() => {
    analytics.track(events.discoveryTileClicked(tileTitle));
  }, [tileTitle]);

export default useTrackClick;
